import React from 'react';
import { Redirect } from 'react-router-dom';

import useUserData from 'data-hooks/useUserData';
import useIsBrowser from 'hooks/useIsBrowser';

const withLoginPage = WrappedComponent => props => {
  const isBrowser = useIsBrowser();
  const { loading: isUserLoading, isLoggedIn } = useUserData();

  if (isUserLoading)
    return (
      <div className="text-lg font-bold flex items-center justify-center">
        Loading...
      </div>
    );

  // Only redirect if the component has been mounted in the browser to avoid
  // SSR errors.
  const shouldRedirect = !isLoggedIn && isBrowser;

  if (shouldRedirect) {
    const { search, pathname } = window.location;
    const redirect = `redirect=${pathname}`;
    const redirectTo = search ? `${search}&${redirect}` : `?${redirect}`;

    return <Redirect to={`/sign-in/${redirectTo}`} />;
  }

  return <WrappedComponent {...props} />;
};

export default withLoginPage;
